<template>
  <v-dialog v-model="dialog" width="480" @input="limparNovoBoletimSanitario">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on: on }" />
    </template>

    <v-card max-height="490" class="mx-auto overflow-hidden">
      <v-card-title dark class="dialog-titulo ">
        Escolha o lote
      </v-card-title>
      <div class="pa-4 py-0 flex-column">
        <span class="dialog-label">Lote</span>
        <v-text-field color="#BDCCCA" outlined dense persistent-hint
                        v-model="searchLoteProducao" :loading="loading"
                        placeholder="Busque por produtor ou lote de controle" hint="Somente lotes em aberto" >
          <template v-slot:prepend-inner>
              <v-icon color="#BCCCCA" size="14" class="mt-1">fas fa-search</v-icon>
          </template>
        </v-text-field>
      </div>

      <v-divider></v-divider>

<!-- Listagem Lotes -->
      <div class="scroller-lotes">
        <div class="tile-lote ma-4" v-for="lote in listaLoteProducao" :key="'lote__tile__'+lote.cdLoteProducao">
          <div class="d-flex flex-row align-center">
            <v-flex grow class="pa-4">
              <div class="subtitulo-tile-lote">
                Lote {{ lote.nrLoteControle }}
              </div>
              <div class="titulo-tile-lote">
                {{ lote.nmProdutor }}
              </div>
            </v-flex>

            <v-flex shrink class="pa-2">
              <div>
                <v-btn text color="#00C1B6" :to="`boletimSanitario/?lp=${lote.cdLoteProducao}`">SELECIONAR</v-btn>
              </div>
            </v-flex>

          </div>
        </div>
        <v-alert v-if="searchLoteProducao && searchLoteProducao.length > 3 && !loading && listaLoteProducao.length === 0"
                 icon="fas fa-exclamation-triangle" border="bottom" color="#F2F5F3" class="ma-4">
          Não foi encontrado lotes com esse nome de produtor/lote de controle
        </v-alert>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import {RULES} from "../../resources";

export default {
  name: 'NovoBoletimSanitarioDialog',
  components: {},
  data: () => ({
    searchLoteProducao: null,
    loading: false,
    dialog: false,
    listaLoteProducao: [],
  }),
  methods: {
    ...RULES,
    limparNovoBoletimSanitario() {
      this.searchLoteProducao = null
      this.listaLoteProducao = []
    },
    loadListaLoteProducao: _.debounce(function () {
      if (!this.searchLoteProducao || this.searchLoteProducao.length === 0 ) return
      let query = new URLSearchParams()

      if(isNaN(this.searchLoteProducao.substr(0, 3))) {
        query.append("nmProdutor", this.searchLoteProducao)
      }
      else {
        query.append("nrLoteControle", this.searchLoteProducao)
      }

      this.$axios.get('boletim-sanitario/lote-producao-search/', {params: query})
          .then((response) => {
            if (!response.data) return
            if (!response.data[0].data) {
              this.listaLoteProducao = []
              return
            }

            this.listaLoteProducao = response.data[0].data
          })
          .catch(error => {
            this.$store.commit('setSnack', {type: 'error', msg: error})
            this.loading = false
          })
          .finally(() => {
            this.loading = false
          })
    }, 1000),
  },
  watch: {
    searchLoteProducao(val) {
      const searchValido = val && val.length > 3
      this.loading = searchValido

      if (searchValido) this.loadListaLoteProducao()
    },
    active(_) {
      this.resetarCampos()
    },
  },
}
</script>
<style lang="scss" scoped>
@import "src/modules/pedidosRacao/sass/variables";

.dialog-label {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0px;
  color: $gray-300;
}

.dialog-titulo {
  text-align: left;
  font: normal 300 normal 16px/21px Roboto !important;
  letter-spacing: 0;
  color: $gray-500;
  opacity: 1;
  background-color: $gray-100;
}

.subtitulo-tile-lote {
  font-family: Roboto;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 16px;
letter-spacing: 0.4px;
color: #35565B;
}

.titulo-tile-lote {
font-family: Roboto;
font-style: normal;
font-weight: bold;
font-size: 14px;
line-height: 20px;
letter-spacing: 0.25px;
color: #35565B;
}

.tile-lote {
background: #F2F5F3;
border-radius: 4px;
}

.scroller-lotes {
  overflow: hidden;
  overflow-y: auto;
  height: 300px;
}
</style>